var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"works container"},[_c('works',{ref:"detailWorks"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }